import offlineConfig from "@redux-offline/redux-offline/lib/defaults";
import { createOffline } from "@redux-offline/redux-offline";

import createStore from "shared/reduxStore";

import client from "network/client";

const effect = (effect, _action) => {
  if (typeof effect === "function") {
    effect = effect();
  }
  return client().request({ token: store.getState().auth.token, ...effect });
};

const finalOfflineConfig = {
  ...offlineConfig,
  effect,
  discard: (error, action, retries) => {
    if (retries > 0 && error.status >= 400 && error.status < 600) {
      return true;
    } else {
      return offlineConfig.discard(error, action, retries);
    }
  },

  persistOptions: {
    blacklist: ["itemLists", "auth"],
  },
};

const { middleware, enhanceReducer, enhanceStore } = createOffline(
  finalOfflineConfig
);

const store = createStore({ middleware, enhanceReducer, enhanceStore });

export default store;
